import React, { useEffect, useState } from "react";

//custom
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
//import axios
import axios from "axios";

//utils
import {
  check_authorized,
  signoutuser_confirm,
  isloginuser,
  get_userseckey,
  getuniquedeviceid,
  signoutuser,
} from "../../utils/Helper/CheckAuth";
import CallURL from "../../utils/API/CallURL";
import {
  showLoading,
  stopLoading,
  sent_clean_var,
  onlynumber,
  fun_input_focus,
} from "../../utils/Helper/JSHelper";

function TopicCard(props) {
  //props
  const { course_id, afteradd, edit_add, is_admin, item_info } = props;

  //const variable
  const [topic_id, set_topic_id] = useState(
    edit_add == "edit" ? item_info.topic_id : ""
  );
  const [topic_seq, set_topic_seq] = useState(
    edit_add == "edit" ? item_info.topic_seq : ""
  );
  const [topic_name, set_topic_name] = useState(
    edit_add == "edit" ? item_info.topic_name : ""
  );
  const [topic_textcolor, set_topic_textcolor] = useState(
    edit_add == "edit" ? item_info.topic_textcolor : "#ffffff"
  );
  const [topic_backcolor, set_topic_backcolor] = useState(
    edit_add == "edit" ? item_info.topic_backcolor : "#f50057"
  );
  const [topic_sts, set_topic_sts] = useState(
    edit_add == "edit" ? item_info.topic_sts : ""
  );
  const [updatetime, set_updatetime] = useState(
    edit_add == "edit" ? item_info.updatetime : ""
  );
  const [entrytime, set_entrytime] = useState(
    edit_add == "edit" ? item_info.entrytime : ""
  );

  //extra variable
  const [is_edit_show, set_is_edit_show] = useState(false);

  //action on user card
  //add item
  function add_edit_item() {
    if (topic_seq == "") {
      alert("Enter Topic Sequence");
      fun_input_focus(topic_id + "frm_topic_seq");
    } else if (topic_name.trim() == "") {
      alert("Enter Topic Name");
      fun_input_focus(topic_id + "frm_topic_name");
    } else {
      //showLoading
      showLoading();
      // Create an object of formData
      const formData = new Object();
      // Update the formData object
      formData.secuserkey = get_userseckey();
      formData.deviceid = getuniquedeviceid();
      //extra variable
      formData.course_id = course_id;
      formData.edit_add = edit_add;
      formData.topic_id = topic_id;
      formData.topic_seq = topic_seq;
      formData.topic_name = sent_clean_var(topic_name.trim());
      formData.topic_textcolor = topic_textcolor;
      formData.topic_backcolor = topic_backcolor;
      // Send formData object
      axios
        .post(CallURL.add_edit_topic, formData)
        .then((response) => {
          //stopLoading
          stopLoading();
          //console.log(response);
          //alert(response.data.apires);
          if (response.data.apires == "unauthorized") {
            //make logout
            signoutuser();
          } else if (response.data.apires == "success") {
            if (edit_add == "add") {
              afteradd();
              //reset data
              set_topic_seq("");
              set_topic_name("");
            } else if (edit_add == "edit") {
              load_item();
              set_is_edit_show(false);
            }
          } else if (response.data.apires == "duplicate") {
            alert("This Topic name already present.");
          } else {
            alert("Something went wrong. Try again.");
          }
        })
        .catch((error) => {
          //stopLoading
          stopLoading();
          console.log(error);
          alert("Something went wrong. Try again.");
        });
    }
  }
  //load_topic
  function load_item() {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    //extra authorized user
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.topic_id = topic_id;
    // Send formData object
    axios
      .post(CallURL.load_topic, formData)
      .then((response) => {
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "success") {
          //set item
          var rows = response.data.rows[0];
          set_topic_id(rows.topic_id);
          set_topic_seq(rows.topic_seq);
          set_topic_name(rows.topic_name);
          set_topic_textcolor(rows.topic_textcolor);
          set_topic_backcolor(rows.topic_backcolor);
          set_topic_sts(rows.topic_sts);
          set_updatetime(rows.updatetime);
          set_entrytime(rows.entrytime);
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        stopLoading();
        alert("Something went wrong. Try again.");
      });
  }
  //change_status
  function change_status(status) {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.topic_id = topic_id;
    formData.status = status;
    // Send formData object
    axios
      .post(CallURL.edit_topic_status, formData)
      .then((response) => {
        //stopLoading
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "unauthorized") {
          //make logout
          signoutuser();
        } else if (response.data.apires == "success") {
          load_item();
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        //stopLoading
        stopLoading();
        console.log(error);
        alert("Something went wrong. Try again.");
      });
  }

  //validate data
  function handle_enter_sequence(e) {
    if (onlynumber(e, 3)) {
      set_topic_seq((topic_seq) => e.target.value);
    }
  }

  return (
    <>
      {(() => {
        const return_text_card = [];
        if (
          (edit_add == "add" && is_admin == "yes") ||
          (is_edit_show && edit_add == "edit" && is_admin == "yes")
        ) {
          return_text_card.push(
            <div className="div_item z-depth-0">
              Topic Sequence
              <input
                type="text"
                placeholder="Topic Sequence"
                id={topic_id + "frm_topic_seq"}
                name={topic_id + "frm_topic_seq"}
                value={topic_seq}
                onChange={(e) => {
                  handle_enter_sequence(e);
                }}
                autoComplete="off"
              />
              Topic Name
              <input
                type="text"
                placeholder="Topic Name"
                id={topic_id + "frm_topic_name"}
                name={topic_id + "frm_topic_name"}
                value={topic_name}
                onChange={(e) => {
                  set_topic_name(e.target.value);
                }}
                autoComplete="off"
              />
              Topic Text Color{" "}
              <input
                type="color"
                placeholder="Topic Text Color"
                value={topic_textcolor}
                onChange={(e) => {
                  set_topic_textcolor(e.target.value);
                }}
              />
              <br />
              Topic Background Color{" "}
              <input
                type="color"
                placeholder="Topic Background Color"
                value={topic_backcolor}
                onChange={(e) => {
                  set_topic_backcolor(e.target.value);
                }}
              />
              <br />
              <br />
              <a
                className="btn green"
                style={{ width: edit_add == "add" ? "100%" : "50%" }}
                onClick={add_edit_item}
              >
                <b>{edit_add == "add" ? "Add" : "Save"} Topic</b>
              </a>
              {edit_add == "edit" ? (
                <a
                  className="btn red"
                  style={{ width: "50%" }}
                  onClick={() => {
                    load_item();
                    set_is_edit_show(false);
                  }}
                >
                  <b>Close</b>
                </a>
              ) : (
                ""
              )}
            </div>
          );
        }
        if (edit_add == "edit" && !is_edit_show) {
          return_text_card.push(
            <div>
              <div className="center">
                {(() => {
                  const return_text = [];
                  if (is_admin == "yes") {
                    return_text.push(
                      <font
                        className="font_sub_small_content_card"
                        style={{
                          color: "black",
                          backgroundColor: "#ffffff",
                          cursor: "pointer",
                        }}
                        onClick={() => set_is_edit_show(true)}
                      >
                        <hr />
                        &nbsp;
                        <i className="fa fa-pencil fa-lg" /> Edit Topic <br />
                      </font>
                    );
                    if (topic_sts == "1") {
                      return_text.push(
                        <font
                          className="font_sub_small_content_card"
                          style={{ color: "green", backgroundColor: "#ffffff" }}
                        >
                          <i className="fa fa-check fa-lg" /> Active Topic{" "}
                          <a
                            className="btn-floating z-depth-1 red"
                            onClick={() => change_status("0")}
                            style={{ zIndex: "0" }}
                          >
                            <i className="fa fa-close"></i>
                          </a>
                        </font>
                      );
                    }
                    if (topic_sts == "0") {
                      return_text.push(
                        <font
                          className="font_sub_small_content_card"
                          style={{ color: "red", backgroundColor: "#ffffff" }}
                        >
                          <i className="fa fa-close fa-lg" /> Deactivated Topic{" "}
                          <a
                            className="btn-floating z-depth-1 green"
                            onClick={() => change_status("1")}
                            style={{ zIndex: "0" }}
                          >
                            <i className="fa fa-check"></i>
                          </a>
                        </font>
                      );
                    }
                  }
                  return return_text;
                })()}
              </div>
              <Link
                to={"/topic/" + topic_id}
                style={{ color: topic_textcolor }}
              >
                <div
                  className="div_item_card z-depth-0 center"
                  style={{
                    color: topic_textcolor,
                    backgroundColor: topic_backcolor,
                  }}
                >
                  <font className="font_sub_title_content_card">
                    {topic_seq}
                  </font>
                  <br />
                  <font className="font_sub_title_content_card">
                    {topic_name}
                  </font>
                  <br />
                </div>
              </Link>
            </div>
          );
        }
        return return_text_card;
      })()}
    </>
  );
}

export default TopicCard;
